import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import Spinner from './Spinner';
const Map = ({ mapRef, loaded }) => {
    const classes = classNames('relative overflow-hidden w-full h-full transition-opacity duration-500', loaded ? 'opacity-100' : 'opacity-0');
    return (_jsxs("div", { className: "w-full h-full bg-green-light", children: [_jsx("div", { className: classes, ref: mapRef }), _jsx(AnimatePresence, { children: !loaded && (_jsx(motion.div, { exit: { opacity: 0 }, className: "absolute inset-0 flex items-center justify-center pointer-events-none", children: _jsx(Spinner, { size: "lg", color: "gold" }) })) })] }));
};
export default Map;
